exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cookieMessage[data-v-20c3a60d]{position:fixed;bottom:0;width:40%;left:30%;border-radius:0!important;margin-bottom:0;z-index:10}.cookieMessage.mobileLayout[data-v-20c3a60d]{width:100%;left:0;bottom:unset}", ""]);

// exports
